<template>
  <div class="content">
    <router-view></router-view>
  </div>
</template>
